import React from 'react';
import { useStaticQuery, graphql } from "gatsby"
import styled from 'styled-components';
import Social from './social';

const StyledFooter = styled.footer`
	
  	padding: 60px 0 40px 0;
	font-size: 15px;
	background-color: #e5e5e526;
	color: #0b0b0c;
	
	p{
		line-height: 24px;
	}
  	.footerContent{
  		margin-bottom:30px;
  	}
  	.link{
  		font-size:14px;
  	}
`;

const StyledSocialLinks = styled.div`
	margin-bottom: 30px;
  
  	ul {  
    	padding: 0;
    	margin: 0;
    	list-style: none;
    		li{
    		margin-bottom: 0;
    		margin-right: 15px;
    		}

    		a {
      		padding: 0px;
      			svg {
            		width: 16px;
    				height: 16px;
				}
      
    	}
  	}
`;


const Footer = () => {
  
const data = useStaticQuery(graphql`
    query HeaderQuery {
      site {
        siteMetadata {
          title
          social {
        url
        name
      }
        }
      }
    }
  `)
  return (
    
  <StyledFooter>
	<div className="container">
		<div className="footerContent">
			<p>Copyright © {new Date().getFullYear()} {data.site.siteMetadata.title}.<br/>
				Feel free to contact us anytime, anywhere<br/>
				<a className="link" href="/">contact@asirm.com</a>
			</p>
		</div>

		<StyledSocialLinks>
			<Social social={data.site.siteMetadata.social}/>
		</StyledSocialLinks>

	</div>
 </StyledFooter>

);
};

export default Footer;
